import components from './components';
import directives from './directives'

const plugin = {
    install(Vue) {
        for (const prop in components) {
            if (components.hasOwnProperty(prop)) {
                const component = components[prop];
                Vue.component(component.name, component);
            }
        }
        for (const key of Object.keys(directives)) {
            const directive = directives[key];
            Vue.directive(directive.name, directive);
        }
    },
};

export default plugin;
